import { AutocompleteModel, TraitTypeAutocomplete } from '../traits/autocomplete';
import LearningPathwayCollection from '../LearningPathwayCollection';

function traits(commands) {
  return [
    {
      type: TraitTypeAutocomplete,
      model: AutocompleteModel.learningPathwayCollection,
      placeholder: 'Select a collection...',
      label: 'Collection',
      name: 'collectionID',
      required: true,
    },
    {
      type: 'run-command',
      buttonLabel: 'Configure',
      commandName: commands.configure
    },
  ];
}

function componentDefinition(editor, options) {
  const {componentType, componentName, commands} = options;

  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: LearningPathwayCollection,
        traits: traits(commands),
      },
    },
    isComponent: el => el.tagName === componentType.toUpperCase()
  }
}

export default function loadComponent(editor, options = {}) {
  editor.Components.addType(options.componentType, componentDefinition(editor, options));
}
